import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Textfield from "../Textfield/Textfield";
import ErrorMessage from "../ErrorMessage/ErrorMessage";

import styles from "./PasswordField.module.scss";

const PasswordField = ({ id, label, value, onChange, error, placeholder }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => setShowPassword((prev) => !prev);

  return (
    <div className={styles.passwordFieldContainer}>
      <div className={styles.inputWrapper}>
        <Textfield
          id={id}
          label={label}
          type={showPassword ? "text" : "password"}
          value={value}
          handleOnChange={onChange}
          placeholder={placeholder}
          className={styles.passwordInput}
        />
        <span className={styles.iconWrapper} onClick={handleTogglePassword}>
          {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
        </span>
      </div>

      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};

export default PasswordField;
